import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202509: BlogMetaData = {
  title: '2025年9・10月の見学会開催について',
  description:
    '今年度及び来年度の園児募集につき、9月と10月に園の説明会を開催します。教育方針のご紹介と質疑応答を行います',
  thumbnailUrl: '/img/blog-202509-session-info.webp',
  filePath: buildBlogFilePath('2025_09-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
